/**
=========================================================
* JTT React - v2.2.0
=========================================================

* Product Page: https://www.digittrix.com/product/material-dashboard-react
* Copyright 2023 JTT (https://www.digittrix.com)

Coded by www.digittrix.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// JTT React base styles
import borders from "assets/theme-dark/base/borders";

const { borderRadius } = borders;

const avatar = {
  styleOverrides: {
    root: {
      transition: "all 200ms ease-in-out",
    },

    rounded: {
      borderRadius: borderRadius.lg,
    },

    img: {
      height: "auto",
    },
  },
};

export default avatar;
